import React from 'react';
import { Routes, Route } from "react-router-dom";
import { Container, Box } from '@mui/material';

// Import Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Import Page Components
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SearchPage from './pages/SearchPage';
import PostFoundPage from './pages/PostFoundPage';
import PostLostPage from './pages/PostLostPage';
import MyItemsMenuPage from './pages/MyItemsMenuPage';
import MyFoundItemsPage from './pages/MyFoundItemsPage';
import MyLostItemsPage from './pages/MyLostItemsPage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

// Import Admin Page Components
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import ReportManagementPage from './pages/admin/ReportManagementPage';
import PostManagementPage from './pages/admin/PostManagementPage';
import CategoryManagementPage from './pages/admin/CategoryManagementPage';

// Import Auth & Error Handling Components
import { useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminRoute from './components/auth/AdminRoute';
import Loader from './components/common/Loader';
import ErrorBoundary from './components/common/ErrorBoundary';

import EditItemPage from './pages/admin/EditItemPage';

import UserDetailsPage from './pages/admin/UserDetailsPage';

import InboxPage from './pages/InboxPage';
import ChatPage from './pages/ChatPage';

import ItemDetailsPage from './pages/ItemDetailsPage';

import ProfilePage from './pages/ProfilePage';

import FAQPage from './pages/FAQPage';
import TipsPage from './pages/TipsPage';
//blog
import BlogListPage from './pages/BlogListPage'; // <-- కొత్త పేజీని ఇంపోర్ట్ చేయండి
import HowToFindLostCertificate from './pages/blog/HowToFindLostCertificate'; // <-- కొత్త బ్లాగ్ పోస్ట్‌ను ఇంపోర్ట్ చేయండి
import LostItemInRailwayStation from './pages/blog/LostItemInRailwayStation';

//import MessagingPage from './pages/MessagingPage';
function App() {
  const { loading } = useAuth();

  if (loading) {
    return <Loader />; 
  }

  return (
    <Box sx={{ flexGrow: 1, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Container maxWidth="lg" sx={{ mt: 4, flex: 1 }}>
        <ErrorBoundary>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/item/:itemId" element={<ItemDetailsPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
            <Route path="/faq" element={<FAQPage />} /> 
            <Route path="/tips" element={<TipsPage />} />
            <Route path="/blog" element={<BlogListPage />} /> {/* <-- కొత్త రౌట్‌ను జోడించండి */}
            <Route path="/blog/how-to-find-lost-certificate" element={<HowToFindLostCertificate />} />
            <Route path="/blog/lost-item-in-railway-station" element={<LostItemInRailwayStation />} />



            {/* Protected routes */}
            <Route path="/found" element={<PrivateRoute><PostFoundPage /></PrivateRoute>} />
            <Route path="/lost" element={<PrivateRoute><PostLostPage /></PrivateRoute>} />
            <Route path="/my-items-menu" element={<PrivateRoute><MyItemsMenuPage /></PrivateRoute>} />
            <Route path="/my-found-items" element={<PrivateRoute><MyFoundItemsPage /></PrivateRoute>} />
            <Route path="/my-lost-items" element={<PrivateRoute><MyLostItemsPage /></PrivateRoute>} />
            <Route path="/inbox" element={<PrivateRoute><InboxPage /></PrivateRoute>} />
            <Route path="/chat/:conversationId" element={<PrivateRoute><ChatPage /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />

            
            {/* Admin Routes */}
            <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><UserManagementPage /></AdminRoute>} />
            <Route path="/admin/users/:id" element={<AdminRoute><UserDetailsPage /></AdminRoute>} />
            <Route path="/admin/reports" element={<AdminRoute><ReportManagementPage /></AdminRoute>} />
            <Route path="/admin/posts" element={<AdminRoute><PostManagementPage /></AdminRoute>} />
            <Route path="/admin/posts/edit/:id" element={<AdminRoute><EditItemPage /></AdminRoute>} />
            <Route path="/admin/categories" element={<AdminRoute><CategoryManagementPage /></AdminRoute>} />
          </Routes>
        </ErrorBoundary>
      </Container>
      <Footer />
    </Box>
  );
}

export default App;